import React from "react";
const Interactions = ({ children }) => {
  return <div>{children}</div>;
};
export default Interactions;